import { render } from "./FavouriteToggle.vue?vue&type=template&id=01685d44&scoped=true"
import script from "./FavouriteToggle.vue?vue&type=script&lang=js"
export * from "./FavouriteToggle.vue?vue&type=script&lang=js"

import "./FavouriteToggle.vue?vue&type=style&index=0&id=01685d44&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01685d44"]])

export default __exports__